<!--
 * @Author: your name
 * @Date: 2021-04-22 11:29:07
 * @LastEditTime: 2021-05-21 14:08:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/officialSeal/index.vue
-->
<template>
  <div>
    <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSearch" v-model="formInline.nameOrCode" placeholder="品牌供应商名称/编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="formInline.supplierSubject" clearable size="small" placeholder="供应商主体" class="w-100">
					<el-option v-for="(item,index) in gysType" :key="index"
						:label="item.label" :value="item.value"></el-option>
				</el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="formInline.subjectType" clearable size="small" placeholder="主体类型" class="w-100">
					<el-option v-for="(item,index) in ztType" :key="index"
						:label="item.label" :value="item.value"></el-option>
				</el-select>
      </el-form-item>
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSearch" v-model="formInline.applyUserName" placeholder="品牌供应商创建人"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div style="padding-bottom:20px;">品牌供应商总数：{{total}}条</div>
    <el-table v-loading="loading" size="small" :data="tableData" style="width: 100%">
      <el-table-column align="center" width="200" prop="name" label="品牌供应商名称"></el-table-column>
      <el-table-column align="center" prop="date" label="供应商主体">
        <template slot-scope="scope">
          <span v-if="scope.row.supplierSubject==1">公司</span>
          <span v-else-if="scope.row.supplierSubject==2">个人</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="200" prop="date" label="主体类型">
        <template slot-scope="scope">
          <span v-if="scope.row.subjectType==1">媒介代理</span>
          <span v-else-if="scope.row.subjectType==2">机构</span>
          <span v-if="scope.row.subjectType==3">平台</span>
          <span v-else-if="scope.row.subjectType==4">视屏外包</span>
          <span v-if="scope.row.subjectType==5">设计外包</span>
          <span v-else-if="scope.row.subjectType==6">活动外包</span>
          <span v-if="scope.row.subjectType==7">其它</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="subjectName" label="主体名称"></el-table-column>
      <el-table-column align="center" width="200" prop="applyUserName" label="品牌供应商创建人"></el-table-column>
      <el-table-column align="center" prop="applyTime" label="品牌供应商创建时间"></el-table-column>
      <el-table-column v-if="brandType === 'has'" align="center" prop="auditTime" label="审批时间"></el-table-column>
      <el-table-column align="center" prop="auditStatus" label="审批状态">
        <template slot-scope="scope">
          {{ApprovalList[scope.row.auditStatus]}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="date" label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="small" v-if="brandType === 'has'" type="text" @click="detailsClick(scope.row.id)">查看</el-button>
          <el-button size="small" v-else type="text" @click="approvalClick(scope.row.id)">审批</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div style="text-align:right;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="formInline.pageSize"
        layout="sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { brandSupplierPage } from '@/api/approve/brand';
export default {
  props:['brandType'],
  components: {
  },
  data() {
    return {
      loading:false,
      ApprovalList:['','待直属上级审批','直属上级审批不通过','直属上级审批通过'],
      gysType:[
        {label:'公司',value:1},
        {label:'个人',value:2},
      ],//供应商主体
      ztType:[
        {label:'媒介代理',value:1},
        {label:'机构',value:2},
        {label:'平台',value:3},
        {label:'视屏外包',value:4},
        {label:'设计外包',value:5},
        {label:'活动外包',value:6},
        {label:'其它',value:7},
      ],//主体类型
      formInline: {
        auditFlag:this._props.brandType=='stay'?0:1,
        applyUserName:"",
        nameOrCode:"",
        subjectType:"",
        supplierSubject:"",
        pageNum: 1,
        pageSize: 10,
      },
      tableData:[],
      total:0,
    };
  },
  mounted() {
    this.getDataInit()
  },
  methods: {
    //列表数据查询
    getDataInit(){
      this.loading = true;
      brandSupplierPage(this.formInline).then((res) => {
        this.tableData = res.data;
        this.total = res.total;
         this.loading = false;
      })
    },
    //查询
    onSearch(){
      this.formInline.pageNum = 1;
      this.getDataInit()
    },
    //查看
    detailsClick(id){
      let router = this.$router.push({
        path: `/check/contractApproval`,
        query: {id,value:'contractSupplier',type:1},
      });
      window.open(router.href);
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
    //审批
    approvalClick(id){
      let router = this.$router.push({
        path: `/check/contractApproval`,
        query: {id,value:'contractSupplier'},
      });
      window.open(router.href);
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.getDataInit()
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      this.getDataInit()
    }
  },
};
</script>
<style lang="scss" scoped>
.details-top{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.invoiceList {
  display: flex;
  justify-content: space-between;
}
.mt-10 {
  margin-top: 10px;
}

/deep/.el-dialog__header {
  border-bottom: 1px solid #ccc !important;
}

/deep/.select-input-wrap-s {
  .el-input-group__append {
    position: relative;
    width: 35px;
    height: 35px;
    border: none;
    background: #fff;
    padding: 0;
    color: #409eff;
    .iconfont {
      position: absolute;
      top: -2px;
      font-size: 36px !important;
    }
    cursor: pointer;
  }
}
/deep/.select-tag {
  .el-tag__close{
    top: -8px;
  }
}
</style>